export enum MdtFeedbackTypeformFieldRef {
  ServiceLine = 'q1_service_line',
}
